import React from 'react'
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "../About/About.css"
import Customcard from './Customcard';
import Desarrolloweb from "../../images/Content/codigo.png";
import Alojamientoweb from "../../images/Content/red-mundial.png";
import Redes from "../../images/Content/social.png";
import Desarrolloapp from "../../images/Content/sistema-de-gestion-de-contenidos.png";
import Portfolio from "../../images/Content/maleta.png";
import listado from './listado';
import serviciosI from "../../images/Content/servicios.png"


const Servicios = () => {
  return (
    <Container>
    <div className='div-servicios ' data-aos="flip-right">
            <h1 className='titulo-servicio'><img className='icono-titulo' src={serviciosI} />Servicios<img className='icono-titulo' src={serviciosI} /></h1>
            <Row className='row-esp'>
            <Customcard title={"Desarrollo de paginas web"} img={Desarrolloweb} moreInfo= {"Desarrollo de paginas web desde 0. Landing page, e-commerce"}linkTo="/Servicios/desarrollo-web" />
            {/* <Customcard title={"Desarrollo de aplicaciones web"} img={Desarrolloapp} moreInfo={" Creamos aplicaciones web a medida que se adaptan perfectamente a las necesidades de tu negocio."} linkTo="/Servicios"/> */}
            <Customcard title={"Servicio de alojamiento web"} img={Alojamientoweb} moreInfo={"Alojamiento en nuestro propio dominio o uno propio."}linkTo="/Servicios/alojamiento-web"/>
            {/* <Customcard title={"Servicio de manejo de redes"} img={Redes} moreInfo={"Te ayudamos a potenciar tus redes sociales a traves del planeamiento de estrategias efectivas."}linkTo="/Servicios"/> */}
            <Customcard title={"Creacion de portfolios"} img={Portfolio} moreInfo={"Nuestro servicio de creación de portfolios online te ofrece una plataforma personalizada para mostrar tus proyectos, habilidades y logros."}linkTo="/Servicios/portfolio-web"/>
            </Row>
            </div>
    </Container>
  )
}

export default Servicios